<template>
    <section class="component-requirements panel-card">
        <header class="subject text-right">
            <h3>
                {{subject}}
            </h3>
        </header>
        <div class="list-requirements rtl text-right" v-for="(item,index) in items" :key="index">
            <ul>
                <li>
                    <i :class="['d-inline-block mdi','mdi-'+icon]"></i>
                    <p class="d-inline-block" v-html="item.wlc_msg"></p>
                    <p v-html="item.finish_msg"></p>
                </li>
                <!-- <li><i :class="['mdi','mdi-'+icon]"></i> Lorem ipsum, dolor sit amet consectetur adipisicing elit. Vitae vel </li>
                <li><i :class="['mdi','mdi-'+icon]"></i> Lorem ipsum, dolor sit amet consectetur adipisicing elit. Vitae vel </li>
                <li><i :class="['mdi','mdi-'+icon]"></i> Lorem ipsum, dolor sit amet consectetur adipisicing elit. Vitae vel </li> -->
            </ul>
        </div>
    </section>
</template>

<script>
export default {
    name: "component-requirements",
    props: ['subject', 'icon', 'items']
};
</script>

<style lang="less">
@import (reference) "../assets/css/variable.less";
@textColor: #29303b;
.component-requirements {
  .box-clear;
  min-height: 200px;
  .list-requirements {
    li {
      font-size: 14px;
      color: @textColor;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/requirements.vue